import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { changeDeal } from 'bundles/apex/deals/show/store/deal/actions';

import { faPlugCirclePlus, faSign } from '@fortawesome/pro-regular-svg-icons';

import { Empty } from '@buildoutinc/blueprint-react/ui/Empty';
import Modal from 'bundles/apex/deals/connect_to_listing/modal';

import { Button } from 'components/ui/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './styles.scss';

export function ListingEmptyState({ changeDeal, deal, edgeCrm }) {
  const [showModal, setShowModal] = useState(false);

  const handleSave = (listing, researchProperty = null) => {
    const changes = { listing };
    if (researchProperty) {
      changes.researchPropertyId = researchProperty.id;
      changes.researchProperty = researchProperty;
    }
    changeDeal(changes);
    
    //Redirect to listing page once created/connected successfully
    if (listing?.path) {
      window.location.assign(listing.path);
    }
  };

  return (
    <React.Fragment>
      <Empty className="bg-white">
        <Empty.Media>
          <FontAwesomeIcon icon={faSign} />
        </Empty.Media>
        <Empty.Title>This deal isn't connected to a listing</Empty.Title>
        <Empty.Content>Click below to connect an existing listing or create a new one</Empty.Content>
        <Empty.Actions>
          <Button icon={faPlugCirclePlus} label="Connect Listing" onClick={() => setShowModal(true)} />
        </Empty.Actions>
      </Empty>

      <Modal
        deal={deal}
        edgeCrm={edgeCrm}
        show={showModal}
        onClose={() => setShowModal(false)}
        onSave={handleSave}
      />
    </React.Fragment>
  );
}

ListingEmptyState.propTypes = {
  changeDeal: PropTypes.func.isRequired,
  deal: PropTypes.object,
  edgeCrm: PropTypes.bool,
};

const mapStateToProps = state => ({
  deal: state.deal,
  edgeCrm: state.features.edgeCrm,
});

const mapDispatchToProps = {
  changeDeal,
};

export default connect(mapStateToProps, mapDispatchToProps)(ListingEmptyState);
